import Typography from "@material-ui/core/Typography/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT, TIME_FORMAT } from "@constants";
import { PortInState } from "./interface/IPortIn";
import { format } from "date-fns";

interface IParams {
    portInDateTime?: string;
    portInState: PortInState;
}

export const PortInDetails = (props: IParams) => {
    const { portInDateTime, portInState } = props;
    const { t } = useTranslation("portinPage");

    const momentPortInDate = portInDateTime ? new Date(portInDateTime) : undefined;
    const portInDate = momentPortInDate ? format(momentPortInDate, DATE_FORMAT) : "";
    const portInTime = momentPortInDate ? format(momentPortInDate, TIME_FORMAT) : "";

    return (
        <Fragment>
            {portInState === PortInState.SCHEDULED && (
                <Typography align="center" variant="body1">
                    {t("portinSchedule", { date: portInDate, time: portInTime })}
                </Typography>
            )}
            {portInState === PortInState.IN_PROGRESS && (
                <Typography align="center" variant="body1">
                    {t("moveInProgress")}
                </Typography>
            )}
        </Fragment>
    );
};
